/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:47
 * @LastEditTime: 2020-08-28 15:26:37
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\myManuscript\service\getDraft\getDraft.js
 * @Description: 
 */
/*
    Create by LiangYu 2015-12-4
*/
'use strict';
angular.module('getDraftModule', [])
    .controller('getDraftCtrl', ['$scope', '$modalInstance', 'params', 'trsHttpService', 'trsspliceString', 'modalDialog', 'success', function($scope, $modalInstance, params, trsHttpService, trsspliceString, modalDialog, success) {
        initData();

        /**
         * [initData description]
         * @return  {[type]}  [return description]
         */
        function initData() {
            $scope.lists = [];
            $scope.selectedArray = [];
            $scope.recoverTypes = [{
                name:'全部操作类型',
            },{
                name:'传稿',
            },{
                name:'部门提交',
            }];
            $scope.selectedDocType = angular.copy($scope.recoverTypes[0]);
            params.service.forEach(ele => {
                getData(ele);
            });
        }
        function getData(ele) {
            $scope.params = {
                'serviceid': ele.serviceid,
                'methodname': ele.methodname,
            };
            trsHttpService.httpServer('/wcm/mlfcenter.do', $scope.params, 'post').then(function(data) {
                data.forEach(item => {
                    item.type = ele.type;
                    $scope.lists.push(item);
                });
            });
        };
        $scope.isConfirm = function() {
            if($scope.selectedArray.length>0){
                var list0 = [],list1 = [];
                $scope.selectedArray.forEach(ele => {
                    if(ele.type == '传稿'){
                        list0.push(ele);
                    }else if(ele.type == '部门提交'){
                        list1.push(ele);
                    };
                });
                $scope.loadingPromise = Promise.all([takeDraft(list0,0),takeDraft(list1,1)]).then(function([data1,data2]){
                    if(data1 == '成功' && data2 == '成功'){
                        modalDialog.alertType('追回成功', '', 'success', false, function() {
                            success();
                        });
                        $scope.selectedArray = [];
                        $scope.$close();
                    };
                })
            }else{
                modalDialog.alertType('请选择稿件', '', 'info', false, function() {});
            };
        };
        $scope.cancel = function() {
            $scope.$close();
        };
        
        $scope.queryByDropdown = function(type) {
            $scope.lists = [];
            $scope.selectedArray = [];
            if(type == '全部操作类型'){
                params.service.forEach(ele => {
                    getData(ele);
                });
            }else if(type == '传稿'){
                getData(params.service[0]);
            }else if(type == '部门提交'){
                getData(params.service[1]);
            };
        };

        //全选
         $scope.selectAll = function () {
            $scope.selectedArray = $scope.selectedArray.length == $scope.lists.length ? [] : [].concat($scope.lists);
        };
        //单选
         $scope.selectDoc = function (item) {
            if ($scope.selectedArray.indexOf(item) < 0) {
                $scope.selectedArray.push(item);
            } else {
                $scope.selectedArray.splice($scope.selectedArray.indexOf(item), 1);
            };
        };

        /**
         * [takeDraft description]
         * @param   {[type]}  MetaDataId  [MetaDataId description]
         * @return  {[type]}              [return description]
         */
         function takeDraft(list,num) {
            return new Promise(function(resolve,reject){
                if(list.length>0){
                    var params1 = {
                        'serviceid': params.service[num].serviceid,
                        'methodname': params.service[num].darftservice,
                    };
                    if(num == 0){
                        params1.ChnldocIds = trsspliceString.spliceString(list, 'RECID', ',');
                        params1.MetaDataIds = trsspliceString.spliceString(list, 'METADATAID', ',');
                    }else if(num == 1){
                        params1.DepartdocrelIds = trsspliceString.spliceString(list, 'DEPARTDOCRELID', ',');
                    };
                    $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', params1, 'post')
                        .then(function(data) {
                            resolve('成功');
                        }, function(data) {});
                }else{
                    resolve('成功');
                }
            })
        };
    }]);
